<template>
    <v-container fluid>
        <v-card flat>
            <v-card-title>FAQ Management
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="addFaq()"><v-icon small class="mx-2">mdi-plus</v-icon>Add New Faq</v-btn>
            </v-card-title>
        </v-card>
        <v-card flat class="mt-2">
            <v-card-title>
                <template>
                    <v-row>
                        <v-col cols="8">
                            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search Faqs" single-line
                                hide-details></v-text-field>
                        </v-col>
                    </v-row>
                </template>
            </v-card-title>
            <v-data-table :loading="loading" :headers="headers" :items="getFaqs" :search="search" item-key="id"
                single-expand sort-by="category" @click:row="getFaq">
                <template v-slot:item.question="{ item }">
                    <span>
                        {{ item.question | trimLength }}
                    </span>
                </template>
                <template v-slot:item.answer="{ item }">
                    <span>
                        {{ item.answer | trimLength }}
                    </span>
                </template>
                <template v-slot:item.category="{ item }">
                    {{ item.category }}
                </template>
                <template v-slot:item.updated_at="{ item }">
                    {{ item.updated_at | formatDate }}
                </template>
                <template v-slot:item.updatedBy="{ item }">
                    {{ item.updatedBy | trimLength }}
                </template>
                <template v-slot:item.actions="{ }">
                    <v-icon>mdi-pencil</v-icon>
                </template>
            </v-data-table>
        </v-card>
    </v-container>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
export default {
    name: "faqManagement",
    data() {
        return {
            selectedCounty: '',
            loading: false,
            search: "",
            height: window.innerHeight,
            headers: [
                { text: 'Question', value: 'question', align: 'start' },
                { text: 'Answer', value: 'answer' },
                { text: 'Category', value: 'category' },
                { text: 'Updated At', value: 'updated_at', align: 'start' },
                { text: 'Updated By', value: 'updatedBy' },
                { text: 'Actions', value: 'actions' }
            ],
            selectedCategory: ''
        }
    },
    computed: {
        ...mapGetters(["isSuperAdmin", "isClientAdmin", "isAdmin", "getFaqs", "getFaqCategory", "userProfile"]),
        categoryOptions() {
            let temp = this.getFaqCategory.filter(category => category.courtLocationCode.includes(this.selectedCounty));
            return temp.map(category => category.name);
            ///return this.getFaqCategory.map(category => category.name);
        },
    },
    methods: {
        handleCategoryChange() {
            console.log('Hello there')
        },
        getFaq(item) {
            console.log("Selected FAQs: ", item)
            this.$store.commit('setSelectedFaq', item)
            this.$store.commit('setViewFaq', true)
        },
        addFaq() {
            this.$store.commit('setAddFaq', true)
        }
    },
    mounted() {
        this.$store.dispatch("pullFaqs")
        this.$store.dispatch("pullFaqsEs")
        this.$store.dispatch("pullFaqCategories")
        this.$store.dispatch("pullFaqCategoriesEs")
        this.$store.dispatch("pullMaps")
        if (this.isAdmin) {
            this.selectedCounty = this.userProfile.data().courthouse
        } else {
            this.selectedCounty = 'howardcc'
        }
    },
    filters: {
        formatDate(val) {
            if (!val) { return '-' }
            return moment(val).format('L')
        },
        formatDuration(val) {
            if (!val) { return '-' }
            return moment(val).format('mm:ss')
        },
        formatTime(val) {
            if (!val) { return '-' }
            return moment(val).format('LT')
        },
        formatStringTime(val) {
            if (!val) { return '-' }
            return moment(val).format('LTS')
        },
        formatDateFromNow(val) {
            if (!val) { return '-' }
            return moment(val).fromNow();
        },
        trimLength(val) {
            if (typeof val !== 'string') return val
            if (val === null) return val
            if (val === '') return val
            if (val.length <= 100) { return val }
            return `${val.substring(0, 65)}...`
        }
    },
}
</script>